import React from 'react';
import { view } from 'react-easy-state';

export default view((props) => props.value == props.name ? props.children : '');